import types from "./types";
import service from "./service";

const getVoas = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_VOA });
        service
            .getVoas(getState().voa.pagination.actualPage, getState().voa.filters)
            .then(result => {
                dispatch(getAllSuccess(result.list));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const getVoaDetail = voa_id => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_VOA_DETAIL });
        service
            .getVoaDetail(voa_id)
            .then(result => dispatch(getDetailSuccess(result)))
            .catch(err => dispatch(getDetailFail(err)));
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeVoaPage({ page: page }));
        dispatch(getVoas());
    };
};
const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeVoaPage({ page: 1 }));
        dispatch(getVoas());
    };
};

const getDetailSuccess = payload => ({
    type: types.GET_VOA_DETAIL_SUCCESS,
    payload
});

const getDetailFail = payload => ({
    type: types.GET_VOA_DETAIL_FAIL,
    payload
});

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeVoaPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_VOA_SUCCESS,
    payload
});
const getAllFail = error => ({
    type: types.GET_VOA_FAIL,
    payload: error
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

export default {
    getVoas,
    getVoaDetail,
    changePage,
    updateFilter
};
